import { ZoomTransformation } from '../../../common/zoom/models/zoom-model';
import { ZOOM_PADDING } from '../constants';

import * as d3 from 'd3';

export const zoomTransformation: (
  box: { x: number; y: number; width: number; height: number },
  canvas: { width: number; height: number },
  offsetY?: number
) => ZoomTransformation = (box, canvas, offsetY) => {
  //   Set offset
  offsetY = offsetY ? offsetY : 0;

  const boxRectZoom = {
    width: canvas.width,
    height: canvas.height
  };
  const centerX = boxRectZoom.width / 2;
  const centerY = boxRectZoom.height / 2;

  const newTranslateX = -box.x - box.width / 2;
  const newTranslateY = -box.y - box.height / 2;
  const scaleTo = Math.min(
    (boxRectZoom.width - (ZOOM_PADDING + offsetY)) / box.width,
    (boxRectZoom.height - (ZOOM_PADDING + offsetY)) / box.height
  );

  // Reset transform.
  let transform = d3.zoomIdentity;
  // Center [0, 0].
  transform = transform.translate(centerX, centerY + offsetY / 2);
  // Apply scale.
  transform = transform.scale(scaleTo);
  // Center elements.
  transform = transform.translate(newTranslateX, newTranslateY);
  // Add transformation to zoom
  return transform;
};

export const transition: (domElm: HTMLElement) => any = (domElm) => d3.select(domElm).transition().ease(d3.easeQuadInOut).duration(500);
